import { DateTime } from 'luxon';

// in Vergangenheit: am 01.02.2021 10:50 Uhr
// < 1h => in XX min
// < 3h => in X h XX min
// < 1T => in X h
// => X Tage
export const getReadableUntilDateTime = (dateTimeString) => {
  const now = DateTime.now();
  const tt = DateTime.fromISO(dateTimeString);

  if (tt < now) {
    return tt.toFormat("'am' dd.LL.yyyy HH:mm 'Uhr'");
  }

  const diff = tt.diff(now);
  if (diff.as('hours') < 1) {
    return `in ${diff.as('minutes').toFixed(0)} min`;
  } else {
    if (diff.as('hours') < 3) {
      const diffO = diff.shiftTo('hours', 'minutes').toObject();
      return `in ${diffO.hours.toFixed(0)} h ${diffO.minutes.toFixed(0)} min`;
    } else {
      if (diff.as('days') < 1) {
        return `in ${diff.as('hours').toFixed(0)} h`;
      } else {
        if (diff.as('days') < 2) {
          const diffO = diff.shiftTo('days', 'hours').toObject();
          return `in ${diffO.days.toFixed(0)} Tag ${diffO.hours.toFixed(0)} h`;
        } else {
          const days = diff.as('days').toFixed(0);
          return `in ${days} ${pluralize("Tag", "en", days)}`;
        }
      }
    }
  }
}

export const getReadableDateTime = (dateTimeString) => {
  return DateTime.fromISO(dateTimeString).toFormat("dd.LL.yyyy HH:mm");
}

export const getReadableDateTimeVariation = (dateTimeString) => {
  return DateTime.fromISO(dateTimeString).toFormat("dd.LL.yyyy・HH:mm");
}

export const getReadableDate = (dateTimeString) => {
  return DateTime.fromISO(dateTimeString).toFormat("dd.LL.yyyy");
}

export const isInPast = (dateTimeString) => {
  return (DateTime.fromISO(dateTimeString) < DateTime.now()) ? true : false;
}

// export const isInFuture = (dateTimeString) => {
//   return (DateTime.fromISO(dateTimeString) > DateTime.now()) ? true : false;
// }

export const compareDateTimes = (aString, bString) => {
  const a = DateTime.fromISO(aString).valueOf();
  const b = DateTime.fromISO(bString).valueOf();
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

const pluralize = (word, pluralEnding, amount) => {
  return (parseInt(amount) === 1) ? word : word + pluralEnding;
}